import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import logo from "../Images/logo.png";
import { FiFacebook, FiLinkedin, FiYoutube } from "react-icons/fi";
import { aboutLinks } from "../Data";
import ReactCountryFlag from "react-country-flag";

const Footer = () => {
  const quicklinks = [
  { label: "Home", href: "/" },
  { label: "Blogs", href: "/blogs" },
  { label: "Contact Us", href: "/contact-us" },
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Sitemap", href: "/sitemap" }
];

const countryLinks = [
  { label: "Vietnam", href: "/vietnam", code: "VN" },
  { label: "Thailand", href: "/thailand", code: "TH" },
  { label: "Malaysia", href: "/malaysia", code: "MY" },
  { label: "Philippines", href: "/philippines", code: "PH" },
  { label: "Singapore", href: "/singapore", code: "SG" }
]

  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.12
      }
    }
  };

  const fadeUp = {
    hidden: { opacity: 0, y: 25 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.7, ease: "easeOut" }
    }
  };

  return (
    <footer className="footer">
      <motion.div
  className="container footer-wrapper"
  variants={container}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>

  {/* COLUMN 1 */}
  <motion.div className="footer-col col-1" variants={fadeUp}>
          <h4>CONTACT US</h4>
          <div className="footer-block">
            <p><b className="bold">Iris Impulse India Pvt. Ltd.</b></p>
            <p>Call us on : (+91) 9638482211</p>
          </div>
           <div className="footer-block">
            <p><b className="bold">Connect with Our Corporate Office:</b> </p>
            <p>“IRIS HOUSE”, Plot-39, Ward-7/C, Gurukul Road, Gandhidham, Kutch, Gujarat, India – 370201</p>
          </div>
           <div className="footer-block">
            <p><b className="bold">Our Plant Address:</b></p>
            <p>Ashirwad Minechem, Plot-199/200 & 203, GIDC Durgapur, Mandvi-Kutch, Gujarat, India – 370465</p>
          </div>
           <Link
           to="/contact-us"
                  className="outline-btn"
                >
                  CONTACT US
                </Link>
                <div className="social-block">
               <p>FOLLOW US</p> <li className="footer-social">
              <motion.a whileHover={{ scale: 1.15 }} href="https://www.youtube.com/@IrisImpulseIndia" target="_blank"><FiYoutube size={26} /></motion.a>
              <motion.a whileHover={{ scale: 1.15 }} href="https://www.facebook.com/Irisimpulsebentonite" target="_blank"><FiFacebook size={26} /></motion.a>
              <motion.a whileHover={{ scale: 1.15 }} href="https://www.linkedin.com/company/iris-impulse-india-private-limited/" target="_blank"><FiLinkedin size={26} /></motion.a>
            </li>
            </div>
  </motion.div>

  {/* RIGHT SIDE (3 COLS) */}
  <div className="footer-right">
    
    <motion.div className="footer-col" variants={fadeUp}>
       <h4>Company</h4>
          <ul>
           <Link to='/about-us'><li>About Us</li></Link> 
           {aboutLinks.map((item, i) => (
                
                  <Link to={item.url}><motion.li key={i} whileHover={{ x: 3 }}>{item.title} </motion.li></Link>
             
              ))}
          </ul>
    </motion.div>

    <motion.div className="footer-col quick-links-col" variants={fadeUp}>
       <h4>Quick Links</h4>
          <ul>
  {quicklinks.map((item, i) => (
    <motion.li key={i} whileHover={{ x: 3 }}>
      <a href={item.href}>{item.label}</a>
    </motion.li>
  ))}
</ul>
    </motion.div>

    <motion.div className="footer-col" variants={fadeUp}>
     <h4>Products</h4>

          <ul>
            <motion.li whileHover={{ x: 3 }}>
              <a href="/bentonite-minerals">Bentonite Minerals</a>
            </motion.li>
            <motion.li whileHover={{ x: 3 }}>
              <a href="/industrial-minerals">Industrial Minerals</a>
            </motion.li>
          </ul>

          <h4 className="footer-subheading">We Export To</h4>

          <ul>
  {countryLinks.map((item, i) => (
    <motion.li key={i} whileHover={{ x: 3 }}>
      <a href={item.href}>
        <ReactCountryFlag
          countryCode={item.code}
          svg
          style={{
            width: "1.2em",
            height: "1.2em",
            marginRight: "10px",
            verticalAlign: "middle"
          }}
        />
        {item.label}
      </a>
    </motion.li>
  ))}
</ul>
    </motion.div>

  </div>

</motion.div>

      {/* DIVIDER */}
      <motion.div
        className="footer-divider"
        initial={{ opacity: 0, scaleX: 0 }}
        whileInView={{ opacity: 1, scaleX: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      />

      {/* BOTTOM BAR */}
      <motion.div
        className="footer-bottom"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <div className="container">

          <p>
         Copyright <b className="bold">Iris Impulse India Pvt. Ltd.</b> {new Date().getFullYear()}. All copyright and other intellectual property rights in all logos, designs, text, images and other materials on this website are owned by <b className="bold">Iris Impulse India Pvt. Ltd.</b> or appear with permission of the relevant owner. <b className="bold">'Iris Impulse India Pvt. Ltd.'</b> is a registered trade mark. All rights reserved.
          </p>

          <motion.div
            className="footer-logo"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
          >
            <img src={logo} alt="Iris Impulse India Pvt. Ltd. Logo" />
          </motion.div>

        </div>
      </motion.div>

    </footer>
  );
};

export default Footer;